import React from 'react'
import styles from './About.module.css'
import NavbarContained from '../../components/NavbarContained/NavbarContained'
import Footer from '../../components/Footer/Footer'

const About = () => {
    return (
        <>
            <NavbarContained />
            <h1 className={styles.heading}>About Us</h1>
            <div className={styles.para}>
                <h2 className={styles.heading2}>Our Mission</h2>
                <p>
                    Welcome to our platform! We are dedicated to providing information and resources on Ayurveda and Homeopathy to help you make informed decisions about your health and well-being.
                </p>
                <p>
                    Our mission is to bridge the gap between conventional and alternative medicine, offering a comprehensive encyclopedia, symptom checker, doctor directory, community interaction, remedies section, meditation guides, and more. We understand that you lead a busy life, and finding trusted service professionals can be a hassle. That's where we come in. With just a few clicks, you can book a variety of services, including:
                </p>
                <ul>
                    <li>Ayurvedic Encyclopedia</li>
                    <li>Homeopathic Encyclopedia</li>
                    <li>Doctor Directory</li>
                    <li>Community Interaction</li>
                    <li>Remedies Section</li>
                    <li>Meditation Guides</li>

                </ul>
                <p>
                    AyurHom is a one-stop-solution for all your Ayurvedic and Homeopathic needs. We're here to help you find the right service professional for your needs, whether you're looking for a doctor, a therapist, or a yoga instructor.
                </p>
                <p>
                    We're proud to be a part of the Atal Innovation Mission, and we look forward to serving you soon!
                </p>
                <b>Supported by:</b>
                <ul>
                    <li>Atal Innovation Mission</li>
                    <li>AIC GGSIPU Foundation Delhi </li>
                    <li>IPU - INNOVATION AND INCUBATION FOUNDATION ( IPU - IIF )</li>
                </ul>
            </div>
            <Footer />
        </>
    )
}

export default About